var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgEye = function SvgEye(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 15,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11 2.5a8.956 8.956 0 0 1 8.085 5.042A8.956 8.956 0 0 1 11 12.582a8.956 8.956 0 0 1-8.085-5.042A8.956 8.956 0 0 1 11 2.5Zm0-1.833C6.417.667 2.502 3.517.917 7.542c1.585 4.024 5.5 6.874 10.083 6.874s8.497-2.85 10.083-6.875C19.498 3.518 15.583.668 11 .668Zm0 4.583a2.292 2.292 0 1 1-.002 4.585A2.292 2.292 0 0 1 11 5.25Zm0-1.833a4.131 4.131 0 0 0-4.125 4.125A4.131 4.131 0 0 0 11 11.665a4.131 4.131 0 0 0 4.125-4.125A4.131 4.131 0 0 0 11 3.417Z",
    fill: "#40424C"
  })));
};
export default SvgEye;